






















































import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import { INFO_SITE, ALT_INFO_SITE } from '@/config';

@Component({
  data: () => ({
    INFO_SITE,
    ALT_INFO_SITE,
  }),
})
export default class Home extends Vue {
  public created() {
    if (!!this.$route.query.showLogin) {
      if (this.loggedIn) {
        this.$router.push('/selectGame?mode=play');
      } else {
        this.$router.push('/login');
      }
    }
    if (!!this.$route.query.showSignUp) {
      if (this.loggedIn) {
        this.$router.push('/selectGame?mode=play');
      } else {
        this.$router.push('/signup');
      }
    }
    if (this.$route.query.showPlay) {
      if (this.loggedIn) {
        this.$router.push('/selectGame?mode=play');
      } else {
        this.$router.push('/selectGame?mode=watch');
      }
    }
  }

  get loggedIn() {
    return store.getters['auth/authenticated'];
  }

  public onSignedUp() {
    this.$router.push('/selectGame?mode=play');
  }

  public onLoggedIn() {
    this.$router.push('/selectGame?mode=play');
  }
}
